import './BarcodeGunShip.css'

import { useState } from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'

import { packageShipping } from '../../../services/shipping'
import errorSound from './errorSound.mp3'

export default function PackageDetails(props) {
  const { item, setSelectedPackage, motherBox } = props
  const [showRespond, setShowRespond] = useState(false)
  const [respond, setRespond] = useState('')
  const [isError, setIsError] = useState(false)
  const [isLoading, setisLoading] = useState(false)
  const [respondHeader, setRespondHeader] = useState('')

  const playErrorSound = () => {
    const audio = new Audio(errorSound)
    audio.play()
  }

  const shipPackage = async () => {
    setisLoading(true)
    const packageToShip = { ...item }
    packageToShip.motherBox = motherBox

    try {
      await packageShipping(packageToShip)

      setRespondHeader('Shipping succeed!')
      setRespond(item.trackingNumberToIsrael)

      setShowRespond(true)
      //so worker can read the msg
      setTimeout(() => {
        setSelectedPackage({})
      }, 1500)
    } catch (error) {
      playErrorSound()
      setRespondHeader('Error! Shipping Failed!')
      setRespond(error.response.data?.error || error.response.data?.msg)
      setIsError(true)
      setShowRespond(true)
    } finally {
      setisLoading(false)
    }
  }

  const pdBarcodeInputHandler = async xlt => {
    if (xlt.length != 12) return

    if (item.valueInUSD >= 2000) {
      playErrorSound()
      setTimeout(() => {
        alert('Package price is too high! \n Package can only shipped from a PC.')
      }, 100)
      return
    }

    if (item.trackingNumberToIsrael === xlt) {
      shipPackage()
    } else {
      playErrorSound()
      setRespondHeader('Error! Wrong XLT number!')
      setRespond('')
      setIsError(true)
      setShowRespond(true)
    }
  }

  return (
    <div className='package-details-cmp'>
      {isLoading ? (
        <div style={{ marginTop: '10%', textAlign: 'center' }}>
          <Spinner animation='border' variant='primary' />
        </div>
      ) : !showRespond ? (
        <>
          <h2>Package Details</h2>
          <div className='pd-main'>
            <div className='pd-detail'> {item.costumer_firstName + ' ' + item.costumer_LastName} </div>
            <div className='pd-detail'> {item.trackingNumberToIsrael} </div>
            <div className='pd-detail'> {item.brand} </div>
            <div className='pd-detail'> {item.weight}KG </div>
            <div className='pd-detail'> {item.dateArrived} </div>
          </div>

          <div className='pd-actions'>
            <div>
              Scan XLT to ship
              <br />
            </div>
            <div>
              <Form.Control
                onChange={e => {
                  pdBarcodeInputHandler(e.target.value)
                }}
                size='sm'
                autoFocus
              ></Form.Control>
            </div>
            <Button
              variant='danger'
              style={{
                backgroundColor: '#e91d1d',
                borderColor: '#e91d1d',
                marginTop: '20px',
              }}
              onClick={() => setSelectedPackage({})}
            >
              Cancel
            </Button>
          </div>
        </>
      ) : (
        <div className={`pd-main ${isError ? 'pd-error' : 'pd-success'}`}>
          <h3>{respondHeader}</h3>
          <br />
          <div>{respond}</div>

          <br />
          <Button variant='danger' onClick={() => setSelectedPackage({})}>
            Close
          </Button>
        </div>
      )}
    </div>
  )
}
